import React, { useState } from "react";
import { Box, MenuItem, Select, TextField } from "@mui/material";
import dayjs from "dayjs"; // For easier date manipulation

const DateFilterDropdown = ({ t, startDate, setStartDate, endDate, setEndDate, direction }) => {
    // Predefined date ranges
    const dateOptions = [
        {
            label: t.filterButton, // Default option
            value: "",
        },
        {
            label: t.Today,
            value: {
                start: dayjs().format("YYYY-MM-DD"), // Change to ISO 8601 format
                end: dayjs().format("YYYY-MM-DD"),
            },
        },
        {
            label: t.Yesterday,
            value: {
                start: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
                end: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
            },
        },
        {
            label: t.Last7Days,
            value: {
                start: dayjs().subtract(7, "days").format("YYYY-MM-DD"),
                end: dayjs().format("YYYY-MM-DD"),
            },
        },
        {
            label: t.ThisMonth,
            value: {
                start: dayjs().startOf("month").format("YYYY-MM-DD"),
                end: dayjs().endOf("month").format("YYYY-MM-DD"),
            },
        },
        { label: t.custom, value: "custom" },
    ];
    const [selectedOption, setSelectedOption] = useState(t.filterButton);

    const [formattedStartDate, setFormattedStartDate] = useState("");
    const [formattedEndDate, setFormattedEndDate] = useState("");

    const handleDateChange = (e) => {
        const selected = e.target.value;
        setSelectedOption(selected);

        if (selected !== "custom") {
            const selectedRange = dateOptions.find(option => option.label === selected);
            setStartDate(selectedRange.value.start);
            setEndDate(selectedRange.value.end);
            setFormattedStartDate(selectedRange.value.start);
            setFormattedEndDate(selectedRange.value.end);
        } else {
            setStartDate("");
            setEndDate("");
            setFormattedStartDate("");
            setFormattedEndDate("");
        }
    };

    const handleCustomDateChange = (setter, formatterSetter) => (e) => {
        const date = e.target.value;
        setter(date);
        formatterSetter(dayjs(date).format("DD-MM-YYYY"));
    };

    // Format the date range for the dropdown display (start-end format)
    const formattedDateRange = selectedOption === "custom"
        ? `${formattedStartDate} - ${formattedEndDate}`
        : selectedOption !== "" && dateOptions.find(option => option.label === selectedOption)
            ? `${dateOptions.find(option => option.label === selectedOption).value.start} - ${dateOptions.find(option => option.label === selectedOption).value.end}`
            : "";
    return (
        <Box>
            {/* Date Dropdown */}
            <Select
                value={selectedOption}
                onChange={handleDateChange}
                displayEmpty
                size="small"
                sx={{
                    width: 200,
                    borderRadius: "12px",
                    color: "var(--text-color)", // Text color
                    borderColor: "var(--primary-color)", // Border color
                    backgroundColor: "var(--secondary-color)", // Background color
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                            borderColor: "var(--primary-color)", // Border color for the input field
                        },
                        "&:hover fieldset": {
                            borderColor: "var(--primary-color)", // Border color on hover
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: "var(--primary-color)", // Border color when focused
                        },
                    },
                }}
            >
                {dateOptions.map((option) => (

                    <MenuItem key={option.label} value={option.label} sx={{ justifyContent: direction === "ltr" ? "flex-end" : "flex-start" }}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>

            {/* Custom Date Pickers */}
            {selectedOption === "custom" && (
                <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                    <TextField
                        type="date"
                        label={t.startDate}
                        value={startDate}
                        onChange={handleCustomDateChange(setStartDate, setFormattedStartDate)}
                        InputLabelProps={{ shrink: true }}
                        sx={{ flex: 1 }}
                    />
                    <TextField
                        type="date"
                        label={t.endDate}
                        value={endDate}
                        onChange={handleCustomDateChange(setEndDate, setFormattedEndDate)}
                        InputLabelProps={{ shrink: true }}
                        sx={{ flex: 1 }}
                    />
                </Box>
            )}
        </Box>
    );
};

export default DateFilterDropdown;
